export const topBarHeight = 50
export const sideNavWidth = 220
export const sideRightNavWidth = 70
export const notificationBarWidth = 280
export const sideRightFullWidth = 280
export const navbarHeight = 60
export const sidenavCompactWidth = 70
export const containedLayoutWidth = 1200